<template>
  <div class="form-group custom-form-group">
    <div class="checkbox-wrapper-header">
      <h3 v-if="label" class="checkbox-wrapper-label mb-0">
        {{ label }}
      </h3>
      <span v-if="enableSelectAll">
        <span>
          {{ $t('common.select') }}
        </span>
        <button class="checkbox-wrapper-header-selector" type="button" @click.prevent="$emit('selectAll', 'All')">
          {{ $t('common.all') }}
        </button>
        <span>
          /
        </span>
        <button class="checkbox-wrapper-header-selector" type="button" @click.prevent="$emit('selectAll', 'None')">
          {{ $t('common.none') }}
        </button>
      </span>
    </div>
    <span v-if="disclaimer" class="custom-form-group-disclaimer">
      {{ disclaimer }}
    </span>
    <div v-if="containerStyle" class="checkbox-container">
      <slot />
    </div>
    <div v-else class="checkbox-wrapper checkbox-wrapper-vertical">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultipleCheckboxes',
  props: {
    label: { type: String },
    disclaimer: { type: String },
    containerStyle: { type: Boolean, default: true },
    enableSelectAll: { type: Boolean, default: true }
  }
};
</script>
